import React, { Component, PureComponent } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Dot, ResponsiveContainer
} from 'recharts';
import moment from "moment";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider
} from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import MaterialTable from 'material-table';
import DownloadCsv from "../common/DownloadCsv"


let referenceRP=[]
  const processRps=(rps)=>{
    let newRps=[]
    let rpsTitle=[]
    for(let i in rps){
      if(i==="0"){
        newRps.push(moment(rps[i].start_date).unix())
      }
      newRps.push(
        moment(rps[i].end_date).unix()
      )
      let ttv=Number(i)+1
      rpsTitle.push("RP-"+ttv)
    }
    referenceRP=newRps;
    return {newRps:newRps,rpsTitle:rpsTitle}
  }
  //function that prepares the data to the new table
  const transformTableColumns=(tableData)=>{
    let ct=0, tmp={}
    let newTable = tableData.map(row=>{
      if(ct===0){
        tmp ={ title:"Metrics", field:"issue", 
        cellStyle: {
          borderRight: "1px solid #d4d4d4"
        }}
      }else{
        tmp = { title: "RP-"+ct, field:"rp"+ct,
        cellStyle: {
          borderRight: "1px solid #d4d4d4"
        }}
      }
      ct++;
      return tmp
    })
    return newTable
  }

  const transformTableData=(tableData)=>{
    let formatter = null;
    if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
    {
      formatter = new Intl.NumberFormat('gt-GT', {
        minimumFractionDigits: 2,
      });
    }
    let newDataTable=[]
    for (let index = 0; index < tableData.length; index++) {
      let cntr=0, tmp={}
      tableData[index].map(row=>{
        if(cntr===0){
          tmp= {"issue": row}
        }else{
          tmp["rp"+cntr]=formatter.format(row.toFixed(2));
        }
        cntr++
        return tmp
      })
      newDataTable.push(tmp)
    }
    return newDataTable
  }

  const processWP=(wps)=>{
       
      let wpsNew=[]
      let caNames=[]
      let today= moment(new Date()).unix()

      for(let i in wps){
        //setting the type of wp
        let tipo=0
        let validDate=moment(wps[i].max_date).unix()
        if(wps[i].completion_date!==null){
          tipo=1
          validDate=moment(wps[i].completion_date).unix()
        }else if(validDate<today){
          tipo=2
        }else{
          tipo=3
        }
        let wptmp={
          y:wps[i].ca_name,
          x:validDate,
          tipo:tipo,
          name:wps[i].name, 
          cost:wps[i].total_cost
        }
        let indice = caNames.indexOf(wps[i].ca_name);      
        if(indice===-1){
          caNames.unshift(wps[i].ca_name)
          let map = new Map()
          map.set(validDate, [wptmp])
          let catmp={
            name:wps[i].ca_name,
            data:[wptmp], 
            map:map
          }
          wpsNew.unshift(catmp)
        }else{
          wpsNew[indice].data.unshift(
            wptmp
          )
          /** updating the map if comes with a new value */
          let mapTmp = wpsNew[indice].map
          if(mapTmp.has(validDate)){
            let tmpArray = mapTmp.get(validDate)
            tmpArray.unshift(wptmp)
            mapTmp.set(validDate,tmpArray)
          }else{
            mapTmp.set(validDate,[wptmp])
          }
          wpsNew[indice].map = mapTmp
        }
      }
      //converting the data to a new value:
      let data2= wpsNew.map(ca=>{
        let controAccount={
          name:ca.name,
          data:[]
        }
        for(let wp of ca.map){
          let wpTmp ={
            x:wp[0],
            y:wp[1][0].y,
            tipo:wp[1].length>1? 4:wp[1][0].tipo,
            data:wp[1]
          }
          controAccount.data.push(wpTmp)
        }
        return controAccount
      })
      
      return data2
  }
  let verticalHeader=["Planner Value (PV)","Cumulative PV","Earned Value (EV)","Cumulative EV","Actual Cost (AC)", "Cumulative AC"]
  class CrpTick extends PureComponent{
    render() {
      const {
        x, y, payload,
      } = this.props;
      let indice = referenceRP.indexOf(payload.value)
      return (
        <g transform={`translate(${x},${y})`}>
            {     indice>0?
                  <text x={-10} y={-20} dy={16} textAnchor="center" fill="#666" fontSize="0.8em" >
                     RP-{indice}
                  </text>
                  :""
            }
        </g>
      );
    }
  }
  class CustomizedAxisTick extends PureComponent {
    render() {
      const {
        x, y, payload,
      } = this.props;
      return (
        <g transform={`translate(${x},${y})`}>
            {
                payload.value>0?
                  <text x={30} y={0} dy={16} textAnchor="end" fill="#666" fontSize="0.65em" >
                      {moment.unix(payload.value).format("MM/DD/YYYY")}
                  </text>
                :
                ""
            }
        </g>
      );
    }
  }

  class ControAccountTick extends PureComponent {
    render() {
      const {
        x, y, payload,
      } = this.props;
      let values = payload.value.split(" ")
      let indexToIgnore = values.indexOf("-")
      let newValues =[]
      let limit = values.length>2?3:values.length
      for (let index = 0; index < limit; index++) {
        if(index!==indexToIgnore){
          newValues.push(values[index].trim().length>10? values[index].slice(0,7)+". . .":values[index])
        }
      }
      let jump=0
      return <text x={x} y={y} width={0} textAnchor="end"  fontSize="0.71em">
              {
                newValues.map(word=>{
                  let output= <tspan x={x} dy={jump+"em"} dx={1} >{word}</tspan>
                  jump = jump+1
                  return output
                })
              }
            </text>
    }
  }

export default class WorkplanView extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props)
  
    this.state = {
       escala:[], 
       data:[], 
       columnsT1:[],
       dataT1:[],
       columnsT2:[], 
       dataT2:[], 
       columnsT3:[], 
       dataT3:[], 
       tableData:[],
       enableDownload:true
    }
    this.settigUpBudgetTable = this.settigUpBudgetTable.bind(this)
    this.settingUpRpTable=this.settingUpRpTable.bind(this)
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
  }


  setDownloadInfo=(info)=>
  {
    let headers=this.state.columnsT3.map(row=>{
      return {label:row.title, key:row.field}
    })
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:headers,
             tableName:"Workplan", 
             type:7
           }
           
     this.setState({
       tableData:value
     })
     setTimeout(() => {
      this.childref.downloadData()
      this.setState({
        enableDownload:true
      })
    }, 500);
   }
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {
            backgroundColor: "#FF000"
          },
          paper: {
            boxShadow: "none"
          }
        },
        MUIDataTableBodyCell: {
          root: {
            border:"1px solid #D8D8D8", 
            fontSize:"0.8em"
          }
        }
      }
    });
  UNSAFE_componentWillMount(){
    this.props.setLoading()
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.fetchData){
      let newScale=processRps(nextProps.fetchData.rps2)
      let loadedData=processWP(nextProps.fetchData.workpackages)
      let columnsT2 =newScale.rpsTitle.slice()
      columnsT2.unshift(" ")
      if(newScale.newRps.length>0 && loadedData.length>0){
        this.setState({
          escala:newScale.newRps.slice(),
          data:loadedData.slice(), 
          columnsT2:columnsT2, 
          columnsT3:transformTableColumns(columnsT2)
        })
        //transformData(columnsT2)
      }
      //setting up for budget table
      if(nextProps.fetchData.cas){
        this.settigUpBudgetTable(nextProps.fetchData.cas)
      }
      if(nextProps.fetchData.rps&&nextProps.fetchData.rps2){
        this.settingUpRpTable(nextProps.fetchData.rps,nextProps.fetchData.rps2);
      }
    }
  }
  settigUpBudgetTable=(data)=>{
    let columnsT1=[]
    let dataT1=[]
    let formatter = null;
    if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
    {
      formatter = new Intl.NumberFormat('gt-GT', {
        minimumFractionDigits: 2,
      });
    }
    for(let i in data){
      columnsT1.push(data[i].name)
      dataT1.push(formatter.format(data[i].total_cost.toFixed(2)))
    }
    this.setState({
      columnsT1:columnsT1,
      dataT1:[dataT1]
    })
  }
  createCustomDot = (dotProps) => {
    const {  payload } = dotProps
    let  markerColor 
    if(payload.tipo===2) {
     markerColor='rgb(253,0,0)'
    }
    if(payload.tipo===1) {
      markerColor = 'rgb(156,214,25)'
    }
    if(payload.tipo===3) {
      markerColor = 'rgb(253,214,72)'
    }
    if(payload.tipo===4){
      markerColor = "rgb(165,188,220)"
    }
    dotProps.fill = markerColor
    dotProps.fillOpacity = 1
    dotProps.r = 7
    dotProps.stroke = '#fff'
    return <Dot {...dotProps} />
  }
  settingUpRpTable=(rps,rps2)=>{
    let firstRowValues=rps2.map(rp=>{
      return 0
    })
    let thirdRowValues = firstRowValues.slice()
    let fifthRowValue=firstRowValues.slice()
    for(let i in rps){
      //filling the firstRowValue
      let indice= rps[i].reporting_number-1
      let frv=firstRowValues[indice]
      frv=frv+rps[i].planned_value
      firstRowValues[indice]=frv
      //filling the third row
      let trv=thirdRowValues[indice]
      trv=trv + rps[i].earned_value
      thirdRowValues[indice]=trv
      //filling the fifth row value
      let ftrv=fifthRowValue[indice]
      ftrv=ftrv+rps[i].actual_cost
      fifthRowValue[indice]=ftrv
    }
    //filling the second row
    let pvc=0
    let secondRowValues=firstRowValues.map((row)=>{
      pvc=pvc+row
      return pvc
    })
    pvc=0
    let fourthRowValues=thirdRowValues.map((row)=>{
      pvc=pvc+row
      return pvc
    })
    pvc=0
    let sixthRowValues=fifthRowValue.map((row)=>{
      pvc=pvc+row
      return pvc
    })
    firstRowValues.unshift(verticalHeader[0])
    secondRowValues.unshift(verticalHeader[1])
    thirdRowValues.unshift(verticalHeader[2])
    fourthRowValues.unshift(verticalHeader[3])
    fifthRowValue.unshift(verticalHeader[4])
    sixthRowValues.unshift(verticalHeader[5])
    let dataT3 =transformTableData([firstRowValues,secondRowValues,thirdRowValues, fourthRowValues,fifthRowValue,sixthRowValues])
    this.setState({
      dataT2:[firstRowValues,secondRowValues,thirdRowValues, fourthRowValues,fifthRowValue,sixthRowValues],
      dataT3:dataT3
    })
    //this.setDownloadInfo(dataT3)
  }
  CustomTooltip = ({ active, payload, label }) => {  
    if (active && payload) {
      return (
        <div style={{backgroundColor:"white", border:"1px solid #E6E6E6", width:"525px"}}>
            <div style={{marginLeft:5, marginRight:5}}>
                <table style={{tableLayout:"fixed",width:"100%",whiteSpace:"nowrap", borderCollapse:"collapse",fontSize:"0.8em",backgroundColor:"#f9f9fa"}} >
                  <tr>
                    <th style={{width:"25%", border:"1px solid #b4b9c3"}}>Work Package</th>
                    <th style={{width:"20%", border:"1px solid #b4b9c3"}}>Date</th>
                    <th style={{width:"18%", border:"1px solid #b4b9c3"}}>Cost</th>
                    <th style={{width:"26%", border:"1px solid #b4b9c3"}}>Control Account</th>
                    <th style={{width:"12%", border:"1px solid #b4b9c3"}}>Status</th>

                  </tr>
                  {payload[0].payload.data.map(wp=>{
                   return (
                    <tr>
                      <td style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis", fontSize:"0.8em", border:"1px solid #b4b9c3"}}>{wp.name}</td>
                      <td style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis", fontSize:"0.8em", border:"1px solid #b4b9c3"}}>{moment.unix(wp.x).format("MM/DD/YYYY")}</td>
                      <td style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis", fontSize:"0.8em", border:"1px solid #b4b9c3"}}>{wp.cost}</td>
                      <td style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis", fontSize:"0.8em", border:"1px solid #b4b9c3"}}>{wp.y}</td>
                      <td style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis", fontSize:"0.8em", border:"1px solid #b4b9c3"}}>{wp.tipo===1?"Done":wp.tipo===2?"Planned":"Delayed"}</td>
                    </tr>
                  )
                  })}
                </table>
            </div>
        </div>
    );
}
  
    return null;
  };
  
 
  render() {
    return (
        <div>
          {this.props.loading? 
          <div style={{marginTop:"10%"}}>
            <Typography align="center">
                Loading
            </Typography>
            <br />
            <div style={{textAlign:"center"}}>
                  <CircularProgress number={100}/>
              </div>
          </div>
          : 
          <div style={{marginTop:50}}>
            <div style={{ marginLeft:"2%",width: '95%', height: 200, marginRight:"2%"}}>
                <ResponsiveContainer width="99%"   >
                  <LineChart >
                    <CartesianGrid strokeDasharray="3 3" />
                      <YAxis dataKey="y" type="category" tick={<ControAccountTick />} />
                      <XAxis dataKey="x" type="number"  
                        domain={["dataMin", 'dataMax']}
                        tick={<CrpTick />}
                        axisLine={false}  
                        ticks={this.state.escala} 
                        interval={0}
                        allowDataOverflow={false}
                        minTickGap={10}
                        scale="linear"
                        xAxisId={1}
                        orientation="top"
                      />
                      <XAxis dataKey="x" type="number"  
                        domain={["dataMin", 'dataMax']}
                        tick={<CustomizedAxisTick/>}
                        axisLine={false}  
                        ticks={this.state.escala} 
                        interval={0}
                        allowDataOverflow={false}
                        minTickGap={10}
                        scale="linear"
                        xAxisId={0}
                      />
                      <Tooltip content={this.CustomTooltip}/>
                      {this.state.data.map(s => (
                        <Line dataKey="y" data={s.data} name={s.name} key={s.name} strokeWidth={2} 
                        dot={this.createCustomDot} isAnimationActive={false}
                        activeDot={{ stroke: '#888', fill: '#888', strokeWidth: 2 }}
                        />
                      ))}
                  </LineChart>
                </ResponsiveContainer>                
            </div>
            <div style={{ marginTop:"15px",marginLeft:"35px"}}> Budget</div>

            <div style={{width:"100%"}}>
              <MuiThemeProvider theme={this.getMuiTheme()} >
                <MUIDataTable
                  title={null}
                  data={this.state.dataT1}
                  columns={this.state.columnsT1}
                  options={{filterType: "dropdown",responsive: "scroll", 
                  search:false, sort:false,filter:false,print:false, download:false,viewColumns:false,pagination:false,
                  selectableRows:"none"}}
                />
              </MuiThemeProvider>
                
            </div>
            <div style={{width:"100%"}}>
              <MaterialTable
               actions={[
                  {
                    icon: 'save',
                    tooltip: 'Save Data',
                    isFreeAction: true,
                    onClick: () => 
                    {
                      if(this.state.enableDownload){
                        this.setDownloadInfo(this.state.dataT3)
                        this.setState({
                          enableDownload:false
                        })
                      }
                    }
                }
                ]}
                options={{
                  actionsColumnIndex:7,
                  paging:false,
                  search:false,
                  sorting:false,
                  maxBodyHeight:"600px",
                  headerStyle: {
                    backgroundColor: '#FFF',
                    color: '#000',
                    fontSize:'1.05em'
                  },
                 
                  rowStyle: (rowData) => {
                      return {
                      backgroundColor: 
                          (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                          '#EEE' 
                          :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                      }
                  }
                }}
                columns={this.state.columnsT3}
                data={this.state.dataT3}
                title=""
              />
              <DownloadCsv 
                  style={{display:"none !important"}} 
                  visible={true}
                  innerRef={node => this.childref = node}
                  tableData={this.state.tableData}
                  ocultar={true}
              />
            </div>
        </div>
      
        }
        </div>
        
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/workplan/WorkplanView.js